import { FormTextField } from '@dfl/mui-react-common';
import { InputAdornment } from '@mui/material';
import { useProductDetail } from 'modules/inventory/product/contexts/ProductDetail';
import { RESPONSIBLE_TYPE_ENUM } from 'modules/inventory/provider/common/constants';
import PriceCell from 'modules/security/audit-logs/components/TableCells/PriceCell';
import { memo, useEffect, useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = {
  selectedProviderType: string;
  setValue?: any;
  control?: any;
};

const FormCompensationField = ({ selectedProviderType, setValue, control }: Props) => {
  const { t } = useTranslation('product');
  const count = useWatch({ control, name: 'quantity' });
  const { product } = useProductDetail();
  const responsible = useWatch({ control, name: 'responsible' });

  const isSupplier = useMemo(() => selectedProviderType === RESPONSIBLE_TYPE_ENUM.SUPPLIER && responsible === product?.providers?.supplier?._id, [selectedProviderType, responsible, product?.providers?.supplier?._id]);

  useEffect(() => {
    let amount = 0;
    if (selectedProviderType === RESPONSIBLE_TYPE_ENUM.CARRIER) {
      amount = count * (product?.finalPrice || 1);
    } else if (isSupplier) {
      amount = 0;
    } else {
      amount = count * (product?.priceDetails?.values?.cost || 1);
    }
    const roundedAmount = parseFloat(amount.toFixed(2));
    setValue?.('compensation', roundedAmount);
  }, [selectedProviderType, count, product?.priceDetails?.values?.cost, product?.finalPrice, setValue, isSupplier]);

  return (
    <>
      <FormTextField
        name="compensation"
        type="number"
        label={t('amountAssociated')}
        readOnly={isSupplier}
        disabled={isSupplier}
        inputProps={{
          inputMode: 'numeric',
          pattern: '[0-9]*',
          min: 0,
          step: 0.01,
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" >
              {!isSupplier &&
                <PriceCell
                  sx={{ fontWeight: 600 }}
                  value={selectedProviderType === RESPONSIBLE_TYPE_ENUM.CARRIER ? product?.finalPrice : product?.priceDetails?.values?.cost}
                />
              }
            </InputAdornment >
          )
        }}
      />
    </>
  );
};

export default memo(FormCompensationField);
